import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { formatNumber } from './getTotalTime';
import { WorkItemWithType } from '../types/workPackages';

const useServiceColumns = (): GridColDef<WorkItemWithType>[] => {
  const { t } = useTranslation();

  return [
    {
      field: 'type',
      headerName: `${t('service.service')} / ${t('material.material')}`,
      flex: 1,
    },
    {
      field: 'wg',
      headerName: t('service.wg'),
      flex: 1,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'supplier',
      headerName: t('service.supplier'),
      flex: 1,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'description',
      headerName: t('service.description'),
      flex: 2,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'areaId',
      headerName: t('workPackage.areaPSP'),
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: params =>
        params === 0 ? '' : String(params).padStart(2, '0'),
    },
    {
      field: 'price',
      headerName: `${t('service.price')} [€]`,
      type: 'number',
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: params => formatNumber(params as number),
    },
  ];
};

const useMaterialColumns = (): GridColDef<WorkItemWithType>[] => {
  const { t } = useTranslation();

  return [
    {
      field: 'type',
      headerName: `${t('service.service')} / ${t('material.material')}`,
      flex: 1,
    },
    {
      field: 'wg',
      headerName: t('material.wg'),
      flex: 1,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'measureUnit',
      headerName: t('material.measureUnit'),
      flex: 1,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'description',
      headerName: t('material.description'),
      flex: 2,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'amount',
      headerName: t('material.amount'),
      flex: 1,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'areaId',
      headerName: t('workPackage.areaPSP'),
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: params =>
        params === 0 ? '' : String(params).padStart(2, '0'),
    },
    {
      field: 'price',
      headerName: `${t('material.price')} [€]`,
      type: 'number',
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: params => formatNumber(params as number),
    },
  ];
};

export { useMaterialColumns, useServiceColumns };
